import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'

import PageSection from '../../PageSection'
import BigBarGraph from '../../Graphs/BigBarGraph'

import { getReusableTooltipCallbackOptions } from '../helpers'

import { GRAPH_COLOR_1 } from '../../../../styles/themes/getDefaultTheme'

import useStyles from '../styles'

const AgeGraphSection = ({ rawGraphData, showAdvancedMetrics, currencySymbol }) => {
  const classes = useStyles()

  const theme = useTheme()

  const ageGraphData = useMemo(() => rawGraphData && rawGraphData.map(data => data.impressions), [rawGraphData])
  const ageGraphLabels = useMemo(() => rawGraphData && rawGraphData.map(data => data.breakdown), [rawGraphData])

  const tooltipCallbackOptions = useMemo(
    () => getReusableTooltipCallbackOptions({ rawGraphData, showAdvancedMetrics, currencySymbol }),
    [currencySymbol, rawGraphData, showAdvancedMetrics]
  )

  return (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>Age</div>
      </div>
      <BigBarGraph
        className={classes.graphWrapper}
        data={ageGraphData}
        labels={ageGraphLabels}
        graphColor={theme[GRAPH_COLOR_1]}
        format="integer"
        tooltipCallbackOptions={tooltipCallbackOptions}
      />
    </PageSection>
  )
}

AgeGraphSection.propTypes = {
  rawGraphData: PropTypes.array.isRequired,
  showAdvancedMetrics: PropTypes.bool,
  currencySymbol: PropTypes.string
}

export default AgeGraphSection
